<div class="sanofi-otpModal__wrapper p-4">
  <div class="sanofi-otpModal__header d-flex align-items-center justify-content-between">
    @if (chooseVerificationStep() && !isLimitReached()) {
      <h3 class="c-heading-h2 font-bold">{{'profile.otp.verifyYourAccount' | cxTranslate }}</h3>
    } @else if (isLimitReached()) {
    <h3 class="c-heading-h2 font-bold">{{ 'profile.otp.verificationLocked' | cxTranslate }}</h3>
  } @else {
    <h3 class="c-heading-h2 font-bold">{{ 'profile.otp.verificationCode' | cxTranslate }}</h3>
  }

    <i class="fa-solid fa-x c-icon-primary c-icon-primary-sm c-icon-round-hover mb-2" (click)="closeModal()"></i>
  </div>
  @if (chooseVerificationStep() && !isLimitReached()) {
    <div class="sanofi-otpModal__body p-3 mt-3">
      <span>{{ 'profile.otp.firstStepSubtitle' | cxTranslate }}</span>
      <form class="mt-4">
        @for (method of otpChoices()?.methods || []; track method.name) {
          <div class="d-flex my-3">
            <input type="radio"
                   value="{{ method.name }}"
                   name="method"
                   id="{{ method.name }}"
                   autocomplete="off"
                   [(ngModel)]="selectedMethod"
                   class="sanofi-otpModal__radio m-0 mr-2"
            />
            <label for="{{ method.name }}" class="sanofi-otpModal__label mb-0">
              {{ 'profile.otp.' + method.name | cxTranslate }} {{ method.value }}
            </label>
          </div>
        }
      </form>
    </div>

    <button type="submit" class="c-button c-button--primary sanofi-otpModal__continueBtn w-100 mt-4"
            (click)="continueFirstStep()"
            [disabled]="!selectedMethod() || disableChoice()"
    >
      {{ 'profile.otp.continue' | cxTranslate }}
    </button>
  } @else if (isLimitReached()) {
    <div class="sanofi-otpModal__body p-3 mt-2">
      <p class="mt-1">{{ 'profile.otp.isLimitReached' | cxTranslate }}</p>
      <p class="mb-1">{{ 'profile.otp.isLimitReached2' | cxTranslate }}</p>
    </div>

    <button class="c-button c-button--primary mt-3 w-100" (click)="closeModal()">Close</button>
  } @else {
    <section>
      <div class="sanofi-otpModal__body p-3 mt-2">
        @if (selectedMethod()) {
          <p>{{ ('profile.otp.verificationCodeSent' + selectedMethod()) | cxTranslate }}</p>
        }
        <p> {{ otpContent()?.maskedDestination }} </p>
        <div class="mt-3">
          @if (timedOut()) {
            <span class="header my-3 d-block">{{ 'profile.otp.requestNew6DigitsCode' | cxTranslate }}</span>
          } @else {
            <span class="header my-3 d-block">{{ 'profile.otp.enterCode' | cxTranslate }}</span>
          }
          <form [formGroup]="otpForm" (ngSubmit)="continue()" class="d-flex justify-content-between flex-fill">
            <input #input1 formControlName="input1" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input1"
                   (input)="(input1.value.length == 1 && input2.value.length < 1) ? input2.focus() : ''"
                   (paste)="inputTriggers('paste', $event, 1)" (keydown)="inputTriggers('delete', $event, 1)">
            <input #input2 formControlName="input2" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input2"
                   (input)="(input2.value.length == 1 && input3.value.length < 1) ? input3.focus() : ''"
                   (paste)="inputTriggers('paste', $event, 2)" (keydown)="inputTriggers('delete', $event, 2)">
            <input #input3 formControlName="input3" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input3"
                   (input)="(input3.value.length == 1 && input4.value.length < 1) ? input4.focus() : ''"
                   (paste)="inputTriggers('paste', $event, 3)" (keydown)="inputTriggers('delete', $event, 3)">
            <input #input4 formControlName="input4" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input4"
                   (input)="(input4.value.length == 1 && input5.value.length < 1) ? input5.focus() : ''"
                   (paste)="inputTriggers('paste', $event, 4)" (keydown)="inputTriggers('delete', $event, 4)">
            <input #input5 formControlName="input5" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input5"
                   (input)="(input5.value.length == 1 && input6.value.length < 1) ? input6.focus() : ''"
                   (paste)="inputTriggers('paste', $event, 5)" (keydown)="inputTriggers('delete', $event, 5)">
            <input #input6 formControlName="input6" type="text" class="sanofi-otpModal__input text-center" maxlength="1" id="input6"
                   (paste)="inputTriggers('paste', $event, 6)" (keydown)="inputTriggers('delete', $event, 6)">
          </form>

          @if (formError()) {

            <p class="sanofi-otpModal__error my-3">{{ 'profile.otp.incorrectCode' | cxTranslate }}</p>
          }

          @if (timedOut()) {
            <p class="sanofi-otpModal__error my-3">{{ 'profile.otp.needToRequestNewCode' | cxTranslate }}</p>
          } @else {
            <div class="my-3">
              <span>{{ 'profile.otp.timeRemaining' | cxTranslate }}</span>
              <span>{{ timeRemaining | async | date:'mm:ss' }}</span>
            </div>
          }
        </div>

        @if (requestNewClicked() && !timedOut()) {
          @if (selectedMethod() === OTP_METHODS.EMAIL) {
            <p class="success">{{ 'profile.otp.newCodeWasSentEmail' | cxTranslate }}</p>
          }

          @if (selectedMethod() === OTP_METHODS.MOBILE) {
            <p class="success">{{ 'profile.otp.newCodeWasSentMobile' | cxTranslate }}</p>
          }
        }
      </div>

      <section class="sanofi-otpModal__footer mt-4">
        @if (selectedMethod() === OTP_METHODS.EMAIL) {
          <p>{{ 'profile.otp.notReceivedCodeEmail' | cxTranslate }}</p>
        }

        @if (selectedMethod() === OTP_METHODS.MOBILE) {
          <p>{{ 'profile.otp.notReceivedCodeMobile' | cxTranslate }}</p>
        }

        @if (!timedOut() && timerNotif()) {
          <p class="w-100">{{ 'profile.otp.timeoutUntilRequestNewCode' | cxTranslate }}</p>
        }

        <div class="d-flex justify-content-between">
          @if (!timedOut()) {
            <button class="c-button c-button--secondary sanofi-otpModal__footerBtn" [ngClass]="timerNotif() ? '' : 'mb-4'" (click)="requestNew('reset', true)"
                    [disabled]="disableRequestNew()">
              {{ 'profile.otp.requestNewCode' | cxTranslate }}
            </button>
          }

          @if (timedOut()) {
            <button class="c-button c-button--primary sanofi-otpModal__continueBtn sanofi-otpModal__footerBtn"
                    (click)="requestNew('requestNew')"
                    [disabled]="disableRequestNew()"
            >
              {{ 'profile.otp.resendCode' | cxTranslate }}
            </button>
          } @else {
            <button type="submit" class="c-button c-button--primary sanofi-otpModal__continueBtn sanofi-otpModal__footerBtn"
                    (click)="continue()"
                    [disabled]="otpForm.invalid || disableContinue()"
            >
              {{ 'profile.otp.continue' | cxTranslate }}
            </button>
          }
        </div>
      </section>
    </section>
  }
</div>
